import { API_ROUTES_FOR_AXIOS } from '../constants/ApiRoutes';
import { axiosInstance } from '../constants/axiosInstance';
import { ApiResponse } from '../types/commonResponseTypes';
import { CreateReviewPayload, ReviewApiResponse } from '../types/review';
import { handleError } from '../utils/commonErrorUtils';

export const createReview = async (
  payload: CreateReviewPayload,
): Promise<ApiResponse<ReviewApiResponse>> => {
  try {
    const { data } = await axiosInstance.post(
      API_ROUTES_FOR_AXIOS['createReview'](),
      payload,
    );

    return data;
  } catch (error: any) {
    return handleError(error);
  }
};

export const getLatestReview = async (): Promise<
  ApiResponse<ReviewApiResponse>
> => {
  try {
    const { data } = await axiosInstance.get(
      API_ROUTES_FOR_AXIOS['getLatestReview'](),
    );

    return data;
  } catch (error: any) {
    return handleError(error);
  }
};
